import React, { useState } from "react";
import { Modal, Box, Typography, Button } from "@mui/material";
import { WarningAmber as WarningIcon } from "@mui/icons-material";

const DeleteUserModal = ({
  deleteModalOpen,
  setDeleteModalOpen,
  handleDeleteUser,
  getAllUsers,
}) => {
  const handleClose = () => {
    setDeleteModalOpen(false);
  };

  const handleDelete = () => {
    handleDeleteUser();
    handleClose();
    getAllUsers();
  };

  return (
    <Modal open={deleteModalOpen} onClose={handleClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 3,
          borderRadius: 2,
          textAlign: "center",
        }}
        className="delete-user-modal"
      >
        <Box sx={{ marginBottom: "40px" }}>
          <Box sx={{ display: "flex" }}>
            <Typography
              color="error"
              sx={{
                background: "rgb(250 212 212)",
                width: "50px",
                height: "50px",
                borderRadius: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "9px",
              }}
            >
              <WarningIcon />
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                marginLeft: "12px",
              }}
            >
              <Typography
                id="delete-confirmation-title"
                variant="h6"
                sx={{ fontSize: "18px", marginBottom: "5px" }}
              >
                Delete User
              </Typography>
              <Typography
                id="delete-confirmation-description"
                sx={{ fontSize: "16px", color: "#9c9b9b" }}
              >
                Are you sure you want to delete user?
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box sx={{ mt: 2, display: "flex", justifyContent: "space-between" }}>
          <Button
            onClick={handleClose}
            sx={{
              textTransform: "none",
              width: "48%",
              border: "1px solid gray",
              color: "gray",
              fontWeight: "500",
              fontSize: "15px",
            }}
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            sx={{
              width: "48%",
              fontWeight: "500",
              fontSize: "15px",
              background: "#fc4f4f",
              color: "white !important",
              "&:hover": {
                background: "#fc4f4f",
                color: "white !important",
              },
            }}
            onClick={handleDelete}
          >
            Delete
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default DeleteUserModal;
